module.exports = __webpack_public_path__ + "assets/img/mecha-btn-9819c09c.png";